import { render, staticRenderFns } from "./layer.vue?vue&type=template&id=0edd3ead&scoped=true&"
import script from "./layer.vue?vue&type=script&lang=js&"
export * from "./layer.vue?vue&type=script&lang=js&"
import style0 from "./layer.vue?vue&type=style&index=0&id=0edd3ead&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd3ead",
  null
  
)

export default component.exports